import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
// import QueueAnim from 'rc-queue-anim';
import { Button, Result } from 'antd';
const Page = () => (_jsx("div", { className: "page-err", children: _jsx(Result, { status: "404", title: "404", subTitle: "Sorry, the page you visited does not exist.", extra: _jsx(Button, { type: "primary", href: "#/", children: "Home" }) }) }));
export default Page;
